<template>
  <div :class="$style.container">
    <InputLayout>
      <template #icon>
        <font-awesome-icon :icon="faSearch" @click="triggerSearch" :class="{[$style.icon]: isHubspot}" />
      </template>
      <input
        name="keyword"
        autocomplete="off"
        v-model="value"
        v-focus
        v-validate="'required|min:2'"
        data-vv-validate-on="none"
        @keyup.enter="triggerSearch"
        :placeholder="placeholder" />
      <template #button>
        <button v-if="hasDial && hasDialpad" @click="toggleMode">
          <DialpadIcon />
        </button>
      </template>
    </InputLayout>
    <p v-if="errors.has('keyword')" :class="$style.error">{{errors.first('keyword')}}</p>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch'
import axios, { CancelToken } from 'axios'
import { jiminnyHost } from '@/helpers/region'
import store from '@/lib/store'
import DialpadIcon from '@/components/shared/DialpadIcon'
import InputLayout from '../shared/InputLayout'
import * as Notifications from './notifications.js'

let cancellationSource
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('dialer')

export default {
  components: {
    InputLayout,
    FontAwesomeIcon,
    DialpadIcon
  },
  data () {
    return {
      faSearch,
      team: store.get('team')
    }
  },
  computed: {
    ...mapState([
      'keyword'
    ]),
    ...mapGetters([
      'hasDial'
    ]),
    hasDialpad () {
      return this.team.features.find(feature => feature.name === 'DIALER_DIALPAD')
    },
    value: {
      get () {
        return this.keyword
      },
      set (value) {
        this.setKeyword(value)

        if (!this.isHubspot) {
          this.triggerSearch()
        }
      }
    },
    placeholder () {
      if (this.team.crm.name === 'Salesforce') {
        return 'Find leads, contacts or accounts'
      } else if (this.team.crm.name === 'HubSpot' || this.team.crm.name === 'Pipedrive') {
        return 'Find contacts, companies'
      } else if (this.team.crm.name === 'Bullhorn') {
        return 'Find candidates, DMs'
      }
    },
    isHubspot () {
      return this.team.crm.name === 'HubSpot'
    }
  },
  methods: {
    ...mapActions([
      'toggleMode',
      'setKeyword',
      'setIsSearching',
      'setSearchResults',
      'setHasSearched'
    ]),
    resetSearch () {
      this.setSearchResults([])
      this.setIsSearching(false)
      this.errors.clear()
    },
    search () {
      this.setIsSearching(true)
      let keyword = this.keyword.toLowerCase()

      if (cancellationSource) {
        cancellationSource.cancel()
      }
      cancellationSource = CancelToken.source()

      axios
        .get(`${jiminnyHost()}/api/v1/crm/search`, {
          cancelToken: cancellationSource.token,
          params: {
            scopes: ['account', 'lead', 'contact'],
            name: keyword
          }
        })
        .then(response => {
          const isSameRequest = keyword === this.keyword.toLowerCase()
          if (isSameRequest) {
            this.setSearchResults(this.keyword && !this.errors.any() ? response.data : [])
            this.setIsSearching(false)
          }
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            return
          }

          console.error(error)
          this.setSearchResults([])
          this.setIsSearching(false)

          Notifications.errorNotification({message: error.response.data.errors.name[0]}).show()
        })
    },
    async triggerSearch () {
      this.setHasSearched(true)
      this.resetSearch()
      if (await this.$validator.validateAll()) {
        this.search()
      }
    }
  }
}
</script>

<style module lang="less" src="./SearchComponent.less"></style>



// WEBPACK FOOTER //
// SearchComponent.vue?469b5b76